var image_viewer_rtlignore_default = {
  "fontElementMap": "vySza",
  "imageContainer": "_8c85B",
  "expandButton": "vB0h2",
  "expandIcon": "vx8ar",
  "pointer": "eO1yr",
  "imageWrapper": "zPKNC",
  "imageRatio": "uh6iL",
  "image": "i6fuj",
  "imageOverlay": "sNRBH",
  "imagePreload": "YOOZe",
  "imageHighres": "LPWBl",
  "onlyHighRes": "szs5E",
  "image_loading": "_9-BGN"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
